import { LANGUAGE_STORAGE_KEY } from '@/i18n/languages';
import { SIGNUP_ORIGIN_STORAGE_KEY } from '@/lib/signupOrigin';

// Le 401 de /auth/me d'un visiteur anonyme passe par ici : l'origine d'inscription doit y survivre.
const PRESERVED_SESSION_KEYS = [SIGNUP_ORIGIN_STORAGE_KEY];
// La langue choisie sur les pages de connexion doit survivre au même 401.
const PRESERVED_LOCAL_KEYS = [LANGUAGE_STORAGE_KEY];

function safeClearStorage(storage?: Storage, preservedKeys: readonly string[] = []): void {
  if (!storage) return;
  try {
    const preserved = preservedKeys.flatMap((key) => {
      const value = storage.getItem(key);
      return value === null ? [] : [[key, value] as const];
    });
    storage.clear();
    for (const [key, value] of preserved) storage.setItem(key, value);
  } catch (error) {
    console.error('Error clearing storage:', error);
  }
}

function clearCookies(): void {
  if (typeof document === 'undefined') return;

  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    if (!name) continue;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`;
  }
}

export function clearClientContext(): void {
  if (typeof window === 'undefined') return;

  safeClearStorage(window.localStorage, PRESERVED_LOCAL_KEYS);
  safeClearStorage(window.sessionStorage, PRESERVED_SESSION_KEYS);
  clearCookies();
}
